import script from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TimeSelector.vue?vue&type=style&index=0&id=bab139bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab139bc"]])

export default __exports__